module.exports = __webpack_public_path__ + "static/media/valid.fa4824f7.svg";